import useMediaQuery from '@mui/material/useMediaQuery';

import { MOBILE_WIDTH_768 } from '../../helpers/constants';

const IsMobileDevice = () => {
  return useMediaQuery(MOBILE_WIDTH_768);
};

export default IsMobileDevice;
